export default {
  List: "/tcs/schedule",
  Create: "/tcs/schedule",
  Update: "/tcs/schedule",
  Detail: "/tcs/schedule",
  Delete: "/tcs/schedule",
  OptionList: "/tcs/schedule/dropdown",
};
